import { Injectable }  from '@angular/core';
import { Observable } from "rxjs";
import { Store } from '@ngrx/store';
import { AppState } from '../reducers';

import * as model from '../models';
import { PriceApi } from './webservice';
import { CombinedPriceLevel } from "../models/ui";
import { PriceLevelActions } from "../actions/pricelevel.actions";
import { SortService } from "../services/sort.service";

@Injectable()
export class PriceLevelService {

	constructor(
		private priceApi: PriceApi,
		private store: Store<AppState>,
		private priceLevelActions: PriceLevelActions,
		private sortService: SortService
	) {}

	public loadPriceLevels(categories: model.Category[]) {
		Observable.from(categories).flatMap(category =>
			Observable.zip(
				this.priceApi.getStandardPriceLevel(category._links.standardPriceLevel.href),
				this.priceApi.getReducedPriceLevels(category._links.reducedPriceLevels.href),
				(standardPrice, reducedPrices) => {
					const sortedReducedPrices = this.sortService.sort(reducedPrices, 'pos');
					return <CombinedPriceLevel>{categoryID: category.uuid, standard: standardPrice, reduced: sortedReducedPrices}
				}
			)
		).toArray().subscribe(combinedPriceLevels => this.store.dispatch(this.priceLevelActions.loadPriceLevelsSuccess(combinedPriceLevels)))
	}
}



// WEBPACK FOOTER //
// ./src/app/services/pricelevel.service.ts